import Vue from 'vue'
import Vuex from 'vuex'

import session from './session'
import menu from './menu'
import code from './code'

Vue.use(Vuex)

const store = new Vuex.Store({
  // strict: true, // process.env.NODE_ENV !== 'production',
  // state    : session/state,
  // mutations: session/mutations,
  // actions  : session/actions,
  // getters  : session/getters,

  modules: {
    strict: process.env.NODE_ENV !== 'production',
    session,
    menu, // this.$store.getters['menu/menuMap']
    code,
  }
})

export default store
